<template>
  <div class="page">
    <ToolsHeader />
    <div class="page-wrapper">
      <div class="block">
        <span class="titel">Algemeen</span>
        <ul>
          <li v-for="(link, index) in algemeen" :key="link.index">
            <span>{{ link.text }}</span>
            <div>
              <a :href="link.link" target="blank">Ga naar pagina</a>
              <a
                v-if="!link.copied"
                @click="copyLink(link.link, index), (link.copied = true)"
                class="btn"
                >Kopieër link</a
              >
              <a v-if="link.copied" class="btn-green">Gekopieërd!</a>
            </div>
          </li>
        </ul>
      </div>

      <div class="block">
        <span class="titel">Aansluiten bij CAD-Tekenaar.com </span>
        <ul>
          <li v-for="(link, index) in aansluiten" :key="link.index">
            <span>{{ link.text }}</span>
            <div>
              <a :href="link.link" target="blank">Ga naar pagina</a>
              <a
                v-if="!link.copied"
                @click="copyLink(link.link, index), (link.copied = true)"
                class="btn"
                >Kopieër link</a
              >
              <a v-if="link.copied" class="btn-green">Gekopieërd!</a>
            </div>
          </li>
        </ul>
      </div>
      <div class="block">
        <span class="titel">Projectvoortgang</span>
        <ul>
          <li v-for="(link, index) in projectvoortgang" :key="link.index">
            <span>{{ link.text }}</span>
            <div>
              <a :href="link.link" target="blank">Ga naar pagina</a>
              <a
                v-if="!link.copied"
                @click="copyLink(link.link, index), (link.copied = true)"
                class="btn"
                >Kopieër link</a
              >
              <a v-if="link.copied" class="btn-green">Gekopieërd!</a>
            </div>
          </li>
        </ul>
      </div>
      <div class="block">
        <span class="titel">Actueel</span>
        <ul>
          <li v-for="(link, index) in actueel" :key="link.index">
            <span>{{ link.text }}</span>
            <div>
              <a :href="link.link" target="blank">Ga naar pagina</a>
              <a
                v-if="!link.copied"
                @click="copyLink(link.link, index), (link.copied = true)"
                class="btn"
                >Kopieër link</a
              >
              <a v-if="link.copied" class="btn-green">Gekopieërd!</a>
            </div>
          </li>
        </ul>
      </div>
      <div class="block">
        <span class="titel">Opdrachtgevers</span>
        <ul>
          <li v-for="(link, index) in opdrachtgevers" :key="link.index">
            <span>{{ link.text }}</span>
            <div>
              <a :href="link.link" target="blank">Ga naar pagina</a>
              <a
                v-if="!link.copied"
                @click="copyLink(link.link, index), (link.copied = true)"
                class="btn"
                >Kopieër link</a
              >
              <a v-if="link.copied" class="btn-green">Gekopieërd!</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsHeader from "./ToolsHeader";
export default {
  name: "tools",
  components: { ToolsHeader },
  data() {
    return {
      links: [
        {
          category: 1,
          copied: false,
          text: "CAD-tekenaar.com",
          link: "https://cad-tekenaar.com"
        },
        {
          category: 1,
          copied: false,
          text: "Afronding aanvraag opdracht pagina",
          link: "https://cad-tekenaar.com/afronden-aanvraag"
        },
        {
          category: 1,
          copied: false,
          text: "Teampagina",
          link: "http://www.team.cad-tekenaar.com"
        },
        {
          category: 1,
          copied: false,
          text: "MailBlue",
          link: "https://cad-tekena7950.activehosted.com/admin/"
        },
        {
          category: 2,
          copied: false,
          text: "Registratie Teampagina CAD-Tekenaar.com",
          link:
            "https://team.cad-tekenaar.com/rmlp/registratie-teampagina-cad-tekenaar-com/"
        },
        {
          category: 2,
          copied: false,
          text: "Voorwaarden",
          link: "https://team.cad-tekenaar.com/rmlp/voorwaarden-samenwerking/"
        },
        {
          category: 3,
          copied: false,
          text: "Opdracht starten",
          link: "https://team.cad-tekenaar.com/teampagina/start-opdracht/"
        },
        {
          category: 3,
          copied: false,
          text: "Tussentijdse facturen/ afmelden opdrachten",
          link: "https://team.cad-tekenaar.com/tussentijds-afmelden/"
        },
        {
          category: 3,
          copied: false,
          text: "Afmelden project",
          link: "https://team.cad-tekenaar.com/teampagina/afronding-project/"
        },
        {
          category: 3,
          copied: false,
          text: "IDeal betaalpagina",
          link: "https://team.cad-tekenaar.com/teampagina/betalen/"
        },
        {
          category: 4,
          copied: false,
          text: "Nieuwe opdrachten (actueel)",
          link: "https://team.cad-tekenaar.com/opdrachten-2/"
        },
        {
          category: 4,
          copied: false,
          text: "Huishoudelijke mededelingen (actueel)",
          link: "https://team.cad-tekenaar.com/blog-nieuws/"
        },
        {
          category: 4,
          copied: false,
          text: "Nieuwtjes",
          link: "https://team.cad-tekenaar.com/nieuws/"
        },
        {
          category: 5,
          copied: false,
          text: "Evaluatieformulier",
          link:
            "https://team.cad-tekenaar.com/rmlp/cad-tekenaar-com-evaluatieformulier/"
        }
      ]
    };
  },
  computed: {
    algemeen() {
      return this.links.filter(link => link.category == 1);
    },
    aansluiten() {
      return this.links.filter(link => link.category == 2);
    },
    projectvoortgang() {
      return this.links.filter(link => link.category == 3);
    },
    actueel() {
      return this.links.filter(link => link.category == 4);
    },
    opdrachtgevers() {
      return this.links.filter(link => link.category == 5);
    }
  },
  methods: {
    copyLink(str, index) {
      var el = document.createElement("textarea");
      // Set value (string to be copied)
      el.value = str;
      // Set non-editable to avoid focus and move outside of view
      el.setAttribute("readonly", "");
      el.style = { position: "absolute", left: "-9999px" };
      document.body.appendChild(el);
      // Select text inside element
      el.select();
      // Copy text to clipboard
      document.execCommand("copy");
      // Remove temporary element
      document.body.removeChild(el);

      this.deCopy(index);
    },
    deCopy(index) {
      const links = this.links;
      setTimeout(function() {
        links[index].copied = false;
      }, 4000);
    }
  }
};
</script>

<style scoped>
ul li {
  display: flex;
  flex-direction: row;
  background: #ffffff;
  padding: 14px;
  border-radius: 6px;
  margin-bottom: 14px;
  font-size: 14px;
  justify-content: space-between;
}

ul li div a {
  border: 1px solid lightgray;
  padding: 8px;
  border-radius: 4px;
  text-decoration: none;
  color: gray;
  margin-left: 14px;
  cursor: pointer;
}

ul li div a:hover {
  background-color: #3076ea;
  border-color: #3076ea;
  color: #fff;
}

.btn:hover {
  background-color: #ff9326;
  border-color: #ff9326;
}

.btn-green {
  background-color: green !important;
  border-color: green !important;
  color: #fff !important;
}

li {
  display: flex;
  align-items: center;
}

.titel {
  font-size: 16px;
  font-weight: 600;
  padding-top: 30px;
  padding-bottom: 10px;
  display: block;
}

li div {
  display: flex;
}

div a {
  white-space: nowrap;
}

.block {
  width: 48%;
}
@media only screen and (max-width: 1100px) {
  .block {
    width: 100%;
  }
}
.page-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
